let token;

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    setToken: t => token = t,
    getToken: () => token,
}